var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Comment_icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.1332 18.704L16.1327 18.7042C14.8058 19.1024 13.4156 19.3053 12.0005 19.3053C5.54023 19.3053 0.5 15.2046 0.5 10.4026C0.5 5.6012 5.54025 1.5 12.0005 1.5C18.4597 1.5 23.5 5.60117 23.5 10.4026C23.5 12.8076 22.2001 15.1756 19.8628 16.8785L19.8626 16.8786L19.6387 17.0419L19.4333 17.1917V17.4459V21.1013L16.9108 18.7314L16.701 18.5343L16.4252 18.6167L16.1332 18.704Z",
    stroke: "#202021"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment_icon.9dd3770a24e796d1e2239667b4b8a0ec.svg";
export { ForwardRef as ReactComponent };